import {ICountry} from '../services/countries.service';

export const COUNTRIES_LIST: ICountry[] = [
  { name: 'Afghanistan', dialCode: '+93', code: 'AF', language: 'fa' },
  { name: 'Albania', dialCode: '+355', code: 'AL', language: 'sq' },
  { name: 'Algeria', dialCode: '+213', code: 'DZ', language: 'ar' },
  { name: 'AmericanSamoa', dialCode: '+1 684', code: 'AS', language: 'en' },
  { name: 'Andorra', dialCode: '+376', code: 'AD', language: 'ca' },
  { name: 'Angola', dialCode: '+244', code: 'AO', language: 'pt' },
  { name: 'Anguilla', dialCode: '+1 264', code: 'AI', language: 'en' },
  { name: 'Antigua and Barbuda', dialCode: '+1268', code: 'AG', language: 'en' },
  { name: 'Argentina', dialCode: '+54', code: 'AR', language: 'es' },
  { name: 'Armenia', dialCode: '+374', code: 'AM', language: 'hy' },
  { name: 'Aruba', dialCode: '+297', code: 'AW', language: 'nl' },
  { name: 'Australia', dialCode: '+61', code: 'AU', language: 'en' },
  { name: 'Austria', dialCode: '+43', code: 'AT', language: 'de' },
  { name: 'Azerbaijan', dialCode: '+994', code: 'AZ', language: 'az' },
  { name: 'Bahamas', dialCode: '+1 242', code: 'BS', language: 'en' },
  { name: 'Bahrain', dialCode: '+973', code: 'BH', language: 'ar' },
  { name: 'Bangladesh', dialCode: '+880', code: 'BD', language: 'bn' },
  { name: 'Barbados', dialCode: '+1 246', code: 'BB', language: 'en' },
  { name: 'Belarus', dialCode: '+375', code: 'BY', language: 'be' },
  { name: 'Belgium', dialCode: '+32', code: 'BE', language: 'nl' },
  { name: 'Belize', dialCode: '+501', code: 'BZ', language: 'en' },
  { name: 'Benin', dialCode: '+229', code: 'BJ', language: 'fr' },
  { name: 'Bermuda', dialCode: '+1 441', code: 'BM', language: 'en' },
  { name: 'Bhutan', dialCode: '+975', code: 'BT', language: 'dz' },
  { name: 'Bosnia and Herzegovina', dialCode: '+387', code: 'BA', language: 'bs' },
  { name: 'Botswana', dialCode: '+267', code: 'BW', language: 'en' },
  { name: 'Brazil', dialCode: '+55', code: 'BR', language: 'pt' },
  { name: 'British Indian Ocean Territory', dialCode: '+246', code: 'IO', language: 'en' },
  { name: 'Bulgaria', dialCode: '+359', code: 'BG', language: 'bg' },
  { name: 'Burkina Faso', dialCode: '+226', code: 'BF', language: 'fr' },
  { name: 'Burundi', dialCode: '+257', code: 'BI', language: 'fr' },
  { name: 'Cambodia', dialCode: '+855', code: 'KH', language: 'km' },
  { name: 'Cameroon', dialCode: '+237', code: 'CM', language: 'fr' },
  { name: 'Canada', dialCode: '+1', code: 'CA', language: 'en' },
  { name: 'Cape Verde', dialCode: '+238', code: 'CV', language: 'pt' },
  { name: 'Cayman Islands', dialCode: '+345', code: 'KY', language: 'en' },
  { name: 'Central African Republic', dialCode: '+236', code: 'CF', language: 'fr' },
  { name: 'Chad', dialCode: '+235', code: 'TD', language: 'fr' },
  { name: 'Chile', dialCode: '+56', code: 'CL', language: 'es' },
  { name: 'China', dialCode: '+86', code: 'CN', language: 'zh' },
  { name: 'Colombia', dialCode: '+57', code: 'CO', language: 'es' },
  { name: 'Comoros', dialCode: '+269', code: 'KM', language: 'ar' },
  { name: 'Congo', dialCode: '+242', code: 'CG', language: 'fr' },
  { name: 'Costa Rica', dialCode: '+506', code: 'CR', language: 'es' },
  { name: 'Croatia', dialCode: '+385', code: 'HR', language: 'hr' },
  { name: 'Cuba', dialCode: '+53', code: 'CU', language: 'es' },
  { name: 'Cyprus', dialCode: '+537', code: 'CY', language: 'el' },
  { name: 'Czech Republic', dialCode: '+420', code: 'CZ', language: 'cs' },
  { name: 'Denmark', dialCode: '+45', code: 'DK', language: 'da' },
  { name: 'Dominican Republic', dialCode: '+1 849', code: 'DO', language: 'es' },
  { name: 'Ecuador', dialCode: '+593', code: 'EC', language: 'es' },
  { name: 'Egypt', dialCode: '+20', code: 'EG', language: 'ar' },
  { name: 'El Salvador', dialCode: '+503', code: 'SV', language: 'es' },
  { name: 'Estonia', dialCode: '+372', code: 'EE', language: 'et' },
  { name: 'Ethiopia', dialCode: '+251', code: 'ET', language: 'am' },
  { name: 'Finland', dialCode: '+358', code: 'FI', language: 'fi' },
  { name: 'France', dialCode: '+33', code: 'FR', language: 'fr' },
  { name: 'Gabon', dialCode: '+241', code: 'GA', language: 'fr' },
  { name: 'Gambia', dialCode: '+220', code: 'GM', language: 'en' },
  { name: 'Georgia', dialCode: '+995', code: 'GE', language: 'ka' },
  { name: 'Germany', dialCode: '+49', code: 'DE', language: 'de' },
  { name: 'Ghana', dialCode: '+233', code: 'GH', language: 'en' },
  { name: 'Greece', dialCode: '+30', code: 'GR', language: 'el' },
  { name: 'Guatemala', dialCode: '+502', code: 'GT', language: 'es' },
  { name: 'Haiti', dialCode: '+509', code: 'HT', language: 'ht' },
  { name: 'Honduras', dialCode: '+504', code: 'HN', language: 'es' },
  { name: 'Hungary', dialCode: '+36', code: 'HU', language: 'hu' },
  { name: 'Iceland', dialCode: '+354', code: 'IS', language: 'is' },
  { name: 'India', dialCode: '+91', code: 'IN', language: 'hi' },
  { name: 'Indonesia', dialCode: '+62', code: 'ID', language: 'id' },
  { name: 'Iran, Islamic Republic of', dialCode: '+98', code: 'IR', language: 'fa' },
  { name: 'Iraq', dialCode: '+964', code: 'IQ', language: 'ar' },
  { name: 'Ireland', dialCode: '+353', code: 'IE', language: 'en' },
  { name: 'Israel', dialCode: '+972', code: 'IL', language: 'he' },
  { name: 'Italy', dialCode: '+39', code: 'IT', language: 'it' },
  { name: 'Jamaica', dialCode: '+1 876', code: 'JM', language: 'en' },
  { name: 'Japan', dialCode: '+81', code: 'JP', language: 'ja' },
  { name: 'Jordan', dialCode: '+962', code: 'JO', language: 'ar' },
  { name: 'Kazakhstan', dialCode: '+7 7', code: 'KZ', language: 'kk' },
  { name: 'Kenya', dialCode: '+254', code: 'KE', language: 'sw' },
  { name: 'Korea, Republic of', dialCode: '+82', code: 'KR', language: 'ko' },
  { name: 'Kuwait', dialCode: '+965', code: 'KW', language: 'ar' },
  { name: 'Kyrgyzstan', dialCode: '+996', code: 'KG', language: 'ky' },
  { name: 'Latvia', dialCode: '+371', code: 'LV', language: 'lv' },
  { name: 'Lebanon', dialCode: '+961', code: 'LB', language: 'ar' },
  { name: 'Lithuania', dialCode: '+370', code: 'LT', language: 'lt' },
  { name: 'Luxembourg', dialCode: '+352', code: 'LU', language: 'lb' },
  { name: 'Madagascar', dialCode: '+261', code: 'MG', language: 'mg' },
  { name: 'Malaysia', dialCode: '+60', code: 'MY', language: 'ms' },
  { name: 'Maldives', dialCode: '+960', code: 'MV', language: 'dv' },
  { name: 'Mali', dialCode: '+223', code: 'ML', language: 'fr' },
  { name: 'Malta', dialCode: '+356', code: 'MT', language: 'mt' },
  { name: 'Mexico', dialCode: '+52', code: 'MX', language: 'es' },
  { name: 'Moldova, Republic of', dialCode: '+373', code: 'MD', language: 'ro' },
  { name: 'Monaco', dialCode: '+377', code: 'MC', language: 'fr' },
  { name: 'Mongolia', dialCode: '+976', code: 'MN', language: 'mn' },
  { name: 'Montenegro', dialCode: '+382', code: 'ME', language: 'sr' },
  { name: 'Morocco', dialCode: '+212', code: 'MA', language: 'ar' },
  { name: 'Mozambique', dialCode: '+258', code: 'MZ', language: 'pt' },
  { name: 'Myanmar', dialCode: '+95', code: 'MM', language: 'my' },
  { name: 'Namibia', dialCode: '+264', code: 'NA', language: 'en' },
  { name: 'Nepal', dialCode: '+977', code: 'NP', language: 'ne' },
  { name: 'Netherlands', dialCode: '+31', code: 'NL', language: 'nl' },
  { name: 'New Zealand', dialCode: '+64', code: 'NZ', language: 'en' },
  { name: 'Nicaragua', dialCode: '+505', code: 'NI', language: 'es' },
  { name: 'Nigeria', dialCode: '+234', code: 'NG', language: 'en' },
  { name: 'Norway', dialCode: '+47', code: 'NO', language: 'no' },
  { name: 'Oman', dialCode: '+968', code: 'OM', language: 'ar' },
  { name: 'Pakistan', dialCode: '+92', code: 'PK', language: 'ur' },
  { name: 'Panama', dialCode: '+507', code: 'PA', language: 'es' },
  { name: 'Paraguay', dialCode: '+595', code: 'PY', language: 'es' },
  { name: 'Peru', dialCode: '+51', code: 'PE', language: 'es' },
  { name: 'Philippines', dialCode: '+63', code: 'PH', language: 'tl' },
  { name: 'Poland', dialCode: '+48', code: 'PL', language: 'pl' },
  { name: 'Portugal', dialCode: '+351', code: 'PT', language: 'pt' },
  { name: 'Qatar', dialCode: '+974', code: 'QA', language: 'ar' },
  { name: 'Romania', dialCode: '+40', code: 'RO', language: 'ro' },
  { name: 'Russia', dialCode: '+7', code: 'RU', language: 'ru' },
  { name: 'Saudi Arabia', dialCode: '+966', code: 'SA', language: 'ar' },
  { name: 'Serbia', dialCode: '+381', code: 'RS', language: 'sr' },
  { name: 'Singapore', dialCode: '+65', code: 'SG', language: 'en' },
  { name: 'Slovakia', dialCode: '+421', code: 'SK', language: 'sk' },
  { name: 'Slovenia', dialCode: '+386', code: 'SI', language: 'sl' },
  { name: 'South Africa', dialCode: '+27', code: 'ZA', language: 'en' },
  { name: 'Spain', dialCode: '+34', code: 'ES', language: 'es' },
  { name: 'Sri Lanka', dialCode: '+94', code: 'LK', language: 'si' },
  { name: 'Sudan', dialCode: '+249', code: 'SD', language: 'ar' },
  { name: 'Sweden', dialCode: '+46', code: 'SE', language: 'sv' },
  { name: 'Switzerland', dialCode: '+41', code: 'CH', language: 'de' },
  { name: 'Syrian Arab Republic', dialCode: '+963', code: 'SY', language: 'ar' },
  { name: 'Taiwan, Province of China', dialCode: '+886', code: 'TW', language: 'zh' },
  { name: 'Tajikistan', dialCode: '+992', code: 'TJ', language: 'tg' },
  { name: 'Tanzania, United Republic of', dialCode: '+255', code: 'TZ', language: 'sw' },
  { name: 'Thailand', dialCode: '+66', code: 'TH', language: 'th' },
  { name: 'Tunisia', dialCode: '+216', code: 'TN', language: 'ar' },
  { name: 'Turkey', dialCode: '+90', code: 'TR', language: 'tr' },
  { name: 'Turkmenistan', dialCode: '+993', code: 'TM', language: 'tk' },
  { name: 'Uganda', dialCode: '+256', code: 'UG', language: 'en' },
  { name: 'Ukraine', dialCode: '+380', code: 'UA', language: 'uk' },
  { name: 'United Arab Emirates', dialCode: '+971', code: 'AE', language: 'ar' },
  { name: 'United Kingdom', dialCode: '+44', code: 'GB', language: 'en' },
  { name: 'United States', dialCode: '+1', code: 'US', language: 'en' },
  { name: 'Uruguay', dialCode: '+598', code: 'UY', language: 'es' },
  { name: 'Uzbekistan', dialCode: '+998', code: 'UZ', language: 'uz' },
  { name: 'Venezuela, Bolivarian Republic of', dialCode: '+58', code: 'VE', language: 'es' },
  { name: 'Viet Nam', dialCode: '+84', code: 'VN', language: 'vi' },
  { name: 'Yemen', dialCode: '+967', code: 'YE', language: 'ar' },
  { name: 'Zambia', dialCode: '+260', code: 'ZM', language: 'en' },
  { name: 'Zimbabwe', dialCode: '+263', code: 'ZW', language: 'en' }
];

// Build a longest-first table of [digitsOnlyDialCode, language]
type CodeLang = { code: string; lang: string };

// Normalize dial codes to digits ("+1 876" -> "1876")
const baseEntries: CodeLang[] = COUNTRIES_LIST
  .filter((c: any) => c.dialCode && c.language)
  .map((c: any) => ({
    code: String(c.dialCode).replace(/\D/g, ''),
    lang: c.language
  }))
  // drop empties just in case
  .filter(e => e.code.length > 0);

// Overrides / special cases (Kazakhstan uses +7 but 76/77 ranges)
const overrides: CodeLang[] = [
  { code: '76', lang: 'kk' },
  { code: '77', lang: 'kk' },
];

// Merge and de-dup by (code, lang) pair
const merged: CodeLang[] = (() => {
  const seen = new Set<string>();
  const arr = [...overrides, ...baseEntries];
  const out: CodeLang[] = [];
  for (const e of arr) {
    const key = `${e.code}|${e.lang}`;
    if (!seen.has(key)) {
      seen.add(key);
      out.push(e);
    }
  }
  // Sort by code length DESC for longest-prefix match
  out.sort((a, b) => b.code.length - a.code.length || a.code.localeCompare(b.code));
  return out;
})();

/**
 * Returns ISO 639-1 language code for a given phone string by dialing code.
 * - Strips all non-digits.
 * - Matches the longest dialing-code prefix first.
 * - Example: "77..." -> "kk" (Kazakhstan), "7..." -> "ru" (Russia).
 */
export function languageByPhone(phone: string, fallback: string | undefined = undefined): string | undefined {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return fallback;

  const hit = merged.find(entry => digits.startsWith(entry.code));
  return hit ? hit.lang : fallback;
}

// Optional helper: exposes what code matched (useful for debugging)
export function languageMatchInfo(phone: string): { language?: string; matchedCode?: string } {
  const digits = String(phone || '').replace(/\D/g, '');
  const hit = merged.find(entry => digits.startsWith(entry.code));
  return hit ? { language: hit.lang, matchedCode: hit.code } : {};
}
